import { render, staticRenderFns } from "./customercatalogs.vue?vue&type=template&id=9a652ad0&scoped=true&"
import script from "./customercatalogs.vue?vue&type=script&lang=js&"
export * from "./customercatalogs.vue?vue&type=script&lang=js&"
import style0 from "./customercatalogs.vue?vue&type=style&index=0&id=9a652ad0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a652ad0",
  null
  
)

export default component.exports